import { useTheme } from '@mui/material/styles';
import React from 'react';

import { InnerStyle, OuterStyle } from './ProcessStepCircle.style';

export default function ProcessStepCircle({
  innerColor,
  outerColor = '',
  onClick,
  hover = false,
  icon = '',
}: {
  innerColor?: string;
  outerColor?: string;
  onClick?: (event: React.MouseEvent<HTMLDivElement>) => void;
  hover?: boolean;
  icon?: string;
}) {
  const { palette } = useTheme();
  const resolvedInnerColor = innerColor ?? palette.background.paper;

  function handleClick(event: React.MouseEvent<HTMLDivElement>) {
    if (onClick) {
      onClick(event);
    }
  }

  if (icon) {
    return (
      <OuterStyle
        color={outerColor}
        data-testid="process-step-circle-outerColor"
        hover={false}
        onClick={handleClick}
      >
        <img alt="step icon" src={icon} />
      </OuterStyle>
    );
  } else if (outerColor) {
    return (
      <OuterStyle
        color={outerColor}
        data-testid="process-step-circle-outerColor"
        hover={hover}
        onClick={handleClick}
      >
        <InnerStyle
          color={resolvedInnerColor}
          data-testid="process-step-circle-innerColor"
        />
      </OuterStyle>
    );
  }

  return null;
}
